function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor" {...props}><path d="M5.6 13.867a.267.267 0 0 1-.267-.267V7.027L.058.433A.267.267 0 0 1 .266 0H13.6a.266.266 0 0 1 .208.433L8.533 7.027v3.906a.267.267 0 0 1-.078.189l-2.667 2.667a.267.267 0 0 1-.188.078z" /></svg>;
});